export default __webpack_public_path__ + "static/media/050_brake_good.ba1a0931.mp3";